import { addMonths, isSameMonth } from 'date-fns';
import getDateMonthAndYear from './getDateMonthAndYear';
import getEarliestDateSafely from './getEarliestDateSafely';
import getFirstPossibleDateMonthAndYear from './getFirstPossibleDateMonthAndYear';
export default function getActiveMonths(_ref) {
  let {
    numberOfMonths,
    startDate,
    endDate,
    minDate,
    maxDate
  } = _ref;
  const firstMonth = getFirstPossibleDateMonthAndYear({
    minDate,
    maxDate,
    earliestDate: getEarliestDateSafely([startDate, endDate])
  });
  let prevMonthDate = firstMonth.date;
  let months = [firstMonth];
  if (numberOfMonths > 1) {
    // set the second month according to the end date.
    if (startDate && endDate) {
      const isSameMonthAsStart = isSameMonth(startDate, endDate);
      if (isSameMonthAsStart) {
        // if the range is in the same month
        months.push(getDateMonthAndYear(addMonths(startDate, 1)));
      } else {
        months.push(getDateMonthAndYear(endDate));
      }
    } else {
      // set the second month as the following.
      months = Array.from(Array(numberOfMonths - 1).keys()).reduce(m => {
        prevMonthDate = addMonths(m[m.length - 1].date, 1);
        return m.concat([getDateMonthAndYear(prevMonthDate)]);
      }, months);
    }
  }
  return months;
}
//# sourceMappingURL=getActiveMonths.js.map